import { type IntlShape } from 'react-intl';
import { type MedicalDirectorPractitionerDetails } from './types';

// Builds the localised AI-scribe appendix that's appended to every note we
// push back into Medical Director. Kept as a plain function (not a hook) so
// it stays trivially unit-testable; the caller supplies an `intl` instance.
export const generateNoteAppendix = ({
  practitionerDetails,
  isConsent,
  intl,
}: {
  practitionerDetails: MedicalDirectorPractitionerDetails | null;
  isConsent: boolean | null | undefined;
  intl: IntlShape;
}) => {
  const practitionerName = practitionerDetails?.Practitioner?.at(0)?.Name;

  const base = intl.formatMessage(
    {
      defaultMessage:
        'This note was generated by an AI scribe, Heidi{hasPractitioner, select, true {, and reviewed by {practitionerName}} other {}}.',
      id: 'f27a1NbOs0',
      description:
        'Appendix appended to notes pushed back into Medical Director, optionally crediting the reviewing practitioner.',
    },
    {
      hasPractitioner: practitionerName ? 'true' : 'false',
      practitionerName: practitionerName ?? '',
    }
  );

  if (!isConsent) return base;

  const consentLine = intl.formatMessage({
    defaultMessage: 'Patient consent was obtained.',
    id: '6Oke3xt6UN',
    description:
      'Second line of the AI-scribe note appendix when patient consent was recorded.',
  });

  return `${base}\n${consentLine}`;
};
